module.exports = __webpack_public_path__ + "img/Mixed-fruits.ef529287.jpg";